<template>
  <div class="container-fluid">
    <h5>Media Upload</h5>

    <div class="vx-row mb-6 mt-2">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Support Images</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="question.configMediaUpload" v-model="question.configMediaUpload.supportImages"/>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Support Videos</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="question.configMediaUpload" v-model="question.configMediaUpload.supportVideos"/>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  name: "QuestionConfigMediaUpload",
  components: {},
  directives: {
  },
  props: ['question'],
  data() {
    return {
    };
  },
  mounted() {
    if (!this.question.configMediaUpload || this.question.configMediaUpload === null) {
        this.question.configMediaUpload = {
            supportImages: true,
            supportVideos: true
        };
    }
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>